import { Link } from "react-router-dom";

export default function ArticleCTASection() {
  return (
    <section className="w-full bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[420px] md:min-h-[520px]">
        <div className="lg:w-1/2 relative overflow-hidden bg-secondary-100/40 min-h-[280px] md:min-h-0">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20workspace%20with%20laptop%20showing%20spreadsheet%20data%20surrounded%20by%20neatly%20arranged%20fashion%20catalog%20magazines%20and%20product%20photos%20on%20cream%20desk%20warm%20ambient%20lighting%20from%20table%20lamp%20cozy%20minimal%20interior%20editorial%20photography%20soft%20shadows%20organic%20composition&width=800&height=1000&seq=guide-cta-img-01&orientation=portrait"
            alt="GTBuy Spreadsheet Guide preview"
            title="GTBuy Spreadsheet - Ultimate Shopping Guide"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute top-6 left-6">
            <span className="text-xs font-medium text-foreground-700 bg-background-50/90 backdrop-blur-sm px-3 py-1.5 rounded-full font-[family-name:var(--font-label)]">
              Guide
            </span>
          </div>
          <div className="absolute bottom-6 left-6 right-6">
            <h3 className="text-2xl md:text-3xl font-bold text-foreground-950 font-[family-name:var(--font-heading)] leading-tight">
              Master Product
              <br />
              Comparison
            </h3>
          </div>
        </div>

        <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 md:px-12 py-12 md:py-16 bg-background-50">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-6 font-[family-name:var(--font-heading)] leading-tight">
            The Ultimate <span className="italic">GTBuy Sheet</span> Guide
          </h2>
          <p className="text-sm md:text-base text-foreground-600 text-center max-w-md leading-relaxed mb-8 font-[family-name:var(--font-body)] font-light">
            Everything you need to know about using the GTBuy spreadsheet system for smarter shopping.
            From setup to advanced comparison techniques, this comprehensive guide covers it all.
          </p>
          <Link
            to="/article/gtbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-950 text-background-50 font-medium text-sm rounded-md hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Read GTBuy Sheet Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}